"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StepSpotlight = void 0;

var _react = _interopRequireWildcard(require("react"));

var _VideoPlayer = require("../../VideoPlayer");

var _PersonalizeControlsHeader = require("../PersonalizeControlsHeader");

var _PersonalizeControlsFooter = require("../PersonalizeControlsFooter");

var _SpotlightControls = require("../../SpotlightControls");

var _StepController = require("../../../molecules/StepController");

var _molecules = require("../../../molecules");

var _atoms = require("../../../atoms");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

// Step Spotlight
var StepSpotlight = function StepSpotlight(_ref) {
  var name = _ref.name,
      moment = _ref.moment,
      updates = _ref.updates,
      onNextStep = _ref.onNextStep,
      buttonTitle = _ref.buttonTitle,
      onCloseClick = _ref.onCloseClick,
      onPreviousStep = _ref.onPreviousStep,
      fullGameMoment = _ref.fullGameMoment,
      showContentInMobile = _ref.showContentInMobile,
      showPreviousButton = _ref.showPreviousButton;
  // Spotlight ref
  var spotlightOverlayRef = (0, _react.useRef)(); // Video player container

  var _useState = (0, _react.useState)(null),
      _useState2 = _slicedToArray(_useState, 2),
      videoNode = _useState2[0],
      setVideoNode = _useState2[1];

  var videoPlayerContainerRef = (0, _VideoPlayer.useVideoContainerRef)();
  (0, _react.useEffect)(function () {
    console.log("StepSpotlight mounted");
    return function () {
      console.log("StepSpotlight unmounted");
    };
  }, []);
  console.log("StepSpotlight VideoController useVideoControls", videoPlayerContainerRef);

  var _useVideoControls = (0, _VideoPlayer.useVideoControls)(videoPlayerContainerRef),
      jump = _useVideoControls.jump; // Next button


  var _useState3 = (0, _react.useState)(true),
      _useState4 = _slicedToArray(_useState3, 2),
      nextButtonDisabled = _useState4[0],
      setNextButtonDisabled = _useState4[1]; // Video timing & spotlight logic


  var momentDuration = updates.stopAtRelative - updates.startAtRelative;

  var _useState5 = (0, _react.useState)(updates.spotlightEnabled),
      _useState6 = _slicedToArray(_useState5, 2),
      spotlightEnabled = _useState6[0],
      _setSpotlightEnabled = _useState6[1];

  var _useState7 = (0, _react.useState)(updates.spotlightStartAtRelative),
      _useState8 = _slicedToArray(_useState7, 2),
      spotlightRelativeStartAt = _useState8[0],
      setSpotlightRelativeStartAt = _useState8[1];

  var callbackRef = (0, _react.useCallback)(function (node) {
    if (node !== null) {
      setVideoNode(document.querySelector(".moment-editor-video-container.spotlight video"));
    }
  }, []); // Setup a listener on the video to determine when the video is ready
  // This allows us to ensure the video frame is established

  (0, _react.useEffect)(function () {
    var enableNextButton = function enableNextButton() {
      setNextButtonDisabled(false);
    };

    if (videoNode) {
      videoNode.addEventListener("canplay", enableNextButton);
      jump(spotlightRelativeStartAt);
    }

    return function () {
      if (videoNode) {
        videoNode.removeEventListener("canplay", enableNextButton);
      }
    };
  }, [videoNode, spotlightRelativeStartAt, jump]); // Styles

  var _useState9 = (0, _react.useState)(updates.overlayStyles),
      _useState10 = _slicedToArray(_useState9, 2),
      overlayStyles = _useState10[0],
      setOverlayStyles = _useState10[1]; // X and Y


  var _useState11 = (0, _react.useState)(updates.spotlightCenterX),
      _useState12 = _slicedToArray(_useState11, 2),
      x = _useState12[0],
      setX = _useState12[1];

  var _useState13 = (0, _react.useState)(updates.spotlightCenterY),
      _useState14 = _slicedToArray(_useState13, 2),
      y = _useState14[0],
      setY = _useState14[1];

  var _useState15 = (0, _react.useState)(false),
      _useState16 = _slicedToArray(_useState15, 2),
      didAdjust = _useState16[0],
      setDidAdjust = _useState16[1];

  var handleCloseClick = function handleCloseClick() {
    onCloseClick();
  };

  var handlePreviousStepClick = function handlePreviousStepClick() {
    setDidAdjust(false);

    if (typeof onPreviousStep === "function") {
      var _updates = {
        didAdjustSpotlight: didAdjust,
        overlayStyles: overlayStyles,
        spotlightCenterX: x,
        spotlightCenterY: y,
        spotlightEnabled: spotlightEnabled,
        spotlightStartAtRelative: spotlightRelativeStartAt
      };
      onPreviousStep(_updates);
    }
  };

  var handleNextStepClick = function handleNextStepClick() {
    setDidAdjust(false);

    if (typeof onNextStep === "function") {
      var _updates2 = {
        didAdjustSpotlight: didAdjust,
        overlayStyles: overlayStyles,
        spotlightCenterX: x,
        spotlightCenterY: y,
        spotlightEnabled: spotlightEnabled,
        spotlightStartAtRelative: spotlightRelativeStartAt
      };
      onNextStep(_updates2);
    }
  };

  var handleStartOnChange = function handleStartOnChange(start) {
    setDidAdjust(true);
    setSpotlightRelativeStartAt(start);
    jump(start);
  };

  var handleOverlayStylesOnChange = function handleOverlayStylesOnChange(overlayStyles) {
    setOverlayStyles(overlayStyles);
  };

  var handleSetX = function handleSetX(newX) {
    setX(newX);
    setDidAdjust(true);
  };

  var handleSetY = function handleSetY(newY) {
    setY(newY);
    setDidAdjust(true);
  }; // Handle display of content in mobile


  var showPreviewInMobileClassName = !showContentInMobile ? "mobile-hide" : "";
  return /*#__PURE__*/_react.default.createElement(_StepController.Step, {
    name: name
  }, /*#__PURE__*/_react.default.createElement(_atoms.Stack, {
    className: "personalize-preview-container",
    xs: _atoms.Stack.Type.Column,
    sm: _atoms.Stack.Type.Column,
    md: _atoms.Stack.Type.Column,
    lg: _atoms.Stack.Type.Row
  }, /*#__PURE__*/_react.default.createElement(_atoms.Column, {
    className: "personalize-preview ".concat(showPreviewInMobileClassName)
  }, /*#__PURE__*/_react.default.createElement(_PersonalizeControlsHeader.PersonalizeControlsHeader, {
    title: "Spotlight",
    className: "mobile",
    onBackClick: onPreviousStep,
    onCloseClick: handleCloseClick,
    showBackButton: showPreviousButton
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: "moment-editor-video-container spotlight"
  }, spotlightEnabled && /*#__PURE__*/_react.default.createElement("div", {
    style: overlayStyles,
    ref: spotlightOverlayRef,
    className: "SpotlightOverlay draggable"
  }), /*#__PURE__*/_react.default.createElement(_VideoPlayer.VideoPlayer, {
    containerRef: videoPlayerContainerRef,
    noMulticam: true,
    muted: true,
    moment: fullGameMoment,
    startAt: spotlightRelativeStartAt,
    mainVideoCallbackRef: callbackRef,
    freeze: true
  }), /*#__PURE__*/_react.default.createElement(_molecules.ProgressBar, {
    className: "moment-preview-progress-bar",
    background: "transparent-color",
    value: spotlightRelativeStartAt - updates.startAtRelative,
    opacity: 1,
    total: momentDuration,
    width: "100%"
  }))), /*#__PURE__*/_react.default.createElement(_atoms.Column, {
    className: "personalize-controls",
    alignItems: "center"
  }, /*#__PURE__*/_react.default.createElement(_PersonalizeControlsHeader.PersonalizeControlsHeader, {
    title: "Spotlight",
    className: "desktop",
    onBackClick: handlePreviousStepClick,
    onCloseClick: handleCloseClick,
    showBackButton: showPreviousButton
  }), /*#__PURE__*/_react.default.createElement(_SpotlightControls.SpotlightControls, {
    moment: moment,
    updates: updates,
    originalRelativeStartAt: updates.startAtRelative,
    spotlightOverlayRef: spotlightOverlayRef,
    spotlightEnabled: spotlightEnabled,
    setSpotlightEnabled: function setSpotlightEnabled(enabled) {
      _setSpotlightEnabled(enabled);

      setDidAdjust(true);
    },
    startAt: spotlightRelativeStartAt,
    setStartAt: handleStartOnChange,
    onChangeOverlayStyles: handleOverlayStylesOnChange,
    videoQuerySelector: ".moment-editor-video-container.spotlight",
    previewQuerySelector: ".personalize-preview",
    x: x,
    y: y,
    setX: handleSetX,
    setY: handleSetY
  }), /*#__PURE__*/_react.default.createElement(_PersonalizeControlsFooter.PersonalizeControlsFooter, {
    buttonDisabled: nextButtonDisabled,
    buttonTitle: buttonTitle,
    onButtonClick: handleNextStepClick
  }))));
};

exports.StepSpotlight = StepSpotlight;
StepSpotlight.defaultProps = {
  showContentInMobile: true,
  onPreviousStep: null,
  moment: null
};